export { default as LoginTemplate } from './Login';
export { default as RegisterTemplate } from './Register';
export { default as ActivationConfirmTemplate } from './ActivationConfirm';
export { default as RegistrationSuccessTemplate } from './RegistrationSuccess';
export { default as PasswordRecoveryTemplate } from './PasswordRecovery';
export { default as PasswordChangeTemplate } from './PasswordChange';
